import { render, staticRenderFns } from "./VideoGrid.vue?vue&type=template&id=47d36720&scoped=true&"
import script from "./VideoGrid.vue?vue&type=script&lang=ts&"
export * from "./VideoGrid.vue?vue&type=script&lang=ts&"
import style0 from "./VideoGrid.vue?vue&type=style&index=0&id=47d36720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d36720",
  null
  
)

export default component.exports